/** WhatsApp Neo Bot demo — Autorização para Venda (trimmed pacing). */

export const TOUR_WHATSAPP_SCRIPT = [
  {
    id: "menu",
    delayMs: 400,
    from: "bot",
    kind: "text",
    text: "Olá, roberto.silva@email.com!\nSaldo: *120* Neo Coins\n\nO que você gostaria de fazer?\n1. Enviar documento para assinatura\n2. Elaborar modelos\n3. Criar Documento\n0. Resetar conversa",
  },
  {
    id: "user-2",
    delayMs: 1400,
    from: "user",
    kind: "text",
    text: "2",
  },
  {
    id: "pick-model",
    delayMs: 2400,
    from: "bot",
    kind: "text",
    text: "Qual documento você quer preencher?\n1. Compromisso de Compra e Venda\n2. Autorização para Venda de Imóvel\n3. Contrato de Locação de Imóvel\n4. Recibo Simples",
  },
  {
    id: "user-model",
    delayMs: 3600,
    from: "user",
    kind: "text",
    text: "2",
  },
  {
    id: "collect",
    delayMs: 4800,
    from: "bot",
    kind: "text",
    text: "Você escolheu: *Autorização para Venda de Imóvel*\n\nMe conte em texto livre os dados (proprietário, intermediador, imóvel, prazo, comissão…). Pode mandar tudo de uma vez.",
  },
  {
    id: "user-data",
    delayMs: 7200,
    from: "user",
    kind: "text",
    text: "Proprietário Roberto Silva Santos CPF 123.456.789-01, imóvel Rua das Flores 250 Jardins SP, Imobiliária Brasil Ltda, prazo 6 meses, comissão 5,5%.",
  },
  {
    id: "confirm",
    delayMs: 9400,
    from: "bot",
    kind: "text",
    text: "Resumo:\n• Proprietário: Roberto Silva Santos\n• Imobiliária: Imobiliária Brasil Ltda.\n• Imóvel: Rua das Flores, 250 — Jardins/SP\n• Prazo: 6 meses · Comissão: 5,5%\n\nConfirma? Responda *sim*.",
  },
  {
    id: "user-sim-pdf",
    delayMs: 11000,
    from: "user",
    kind: "text",
    text: "sim",
  },
  {
    id: "generating",
    delayMs: 12200,
    from: "bot",
    kind: "text",
    text: "Gerando seu documento…",
  },
  {
    id: "pdf",
    delayMs: 14200,
    from: "bot",
    kind: "pdf",
    text: "Autorização para Venda — Rua das Flores, 250.pdf",
  },
  {
    id: "offer-sign",
    delayMs: 15800,
    from: "bot",
    kind: "text",
    text: "Documento pronto! Deseja enviar para assinatura? Responda *sim*.\n\n_(Detecção automática de campos — experimental.)_",
  },
  {
    id: "user-sim-sign",
    delayMs: 17200,
    from: "user",
    kind: "text",
    text: "sim",
  },
  {
    id: "sent",
    delayMs: 19200,
    from: "bot",
    kind: "link",
    text: "Pronto! Detectei os campos e enviei para assinatura.",
    linkLabel: "Abrir para assinar",
    linkUrl: "https://apps.neomodelos.com.br/assinar/demo-tour-autorizacao",
  },
];
